import { downloadImprovementSuggestionAttachment } from '../../../api/improvementSuggestion';
import {
  ADOPTION_ADOPTED,
  ADOPTION_NOT_ADOPTED,
  ADOPTION_PENDING,
  adoptionLabel,
  ImprovementSuggestion,
  SUGGESTION_CATEGORIES,
} from '../../../types/improvementSuggestion';
import ApprovalStampBox from '../ApprovalStampBox';
import { PreviewAttachmentList } from './previewShared';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: ImprovementSuggestion;
}

function ImprovementSuggestionPreviewView({ detail }: Props) {
  const adoptionStatus = detail.adoptionStatus || ADOPTION_PENDING;

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <div>
            <h3 style={{ margin: 0 }}>제안 신청서</h3>
          </div>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            문서번호
            <input value={detail.suggestionNo || '-'} readOnly />
          </label>
          <label>
            제안일
            <input type="date" value={detail.suggestDate?.slice(0, 10) || ''} readOnly />
          </label>
          <label className="is-span-2">
            제목 *
            <input value={detail.title || ''} readOnly />
          </label>
          <label>
            제안자
            <input value={detail.proposerName || ''} readOnly />
          </label>
          <label>
            부서
            <input value={detail.department || ''} readOnly />
          </label>
          <label>
            구분
            <select value={detail.category || ''} disabled>
              <option value="">선택</option>
              {SUGGESTION_CATEGORIES.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
              {detail.category &&
              !(SUGGESTION_CATEGORIES as readonly string[]).includes(detail.category) ? (
                <option value={detail.category}>{detail.category}</option>
              ) : null}
            </select>
          </label>
          <label className="is-span-2">
            현황
            <textarea rows={4} value={detail.currentSituation || ''} readOnly />
          </label>
          <label className="is-span-2">
            제안 내용
            <textarea rows={6} value={detail.proposalContent || ''} readOnly />
          </label>
          <label className="is-span-2">
            기대 효과
            <textarea rows={4} value={detail.expectedEffect || ''} readOnly />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} value={detail.remark || ''} readOnly />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>채택·실시</h3>
        </div>
        <p className="quality-form__hint">
          승인 후 오너/팀장이 채택 여부와 실시 내용을 기록합니다. ({adoptionLabel(adoptionStatus)})
        </p>
        <div className="quality-form__grid">
          <label>
            채택 상태
            <select value={adoptionStatus} disabled>
              <option value={ADOPTION_PENDING}>대기</option>
              <option value={ADOPTION_ADOPTED}>채택</option>
              <option value={ADOPTION_NOT_ADOPTED}>미채택</option>
            </select>
          </label>
          <label>
            실시일
            <input type="date" value={detail.implementedAt?.slice(0, 10) || ''} readOnly />
          </label>
          <label className="is-span-2">
            실시 내용
            <textarea rows={4} value={detail.implementationNote || ''} readOnly />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) =>
            void downloadImprovementSuggestionAttachment(
              detail.improvementSuggestionId,
              file.attachmentId,
              file.fileName
            ).catch(() => undefined)
          }
        />
      </section>
    </div>
  );
}

export default ImprovementSuggestionPreviewView;
